import { getCurrentPlan } from "@/services/subscription/subscription.service"
import { LoadingOutlined } from "@ant-design/icons"
import { useRequest } from "ahooks"
import { Button, Result, Spin } from "antd"

export const CheckoutResult = () => {
  const {data: userSubscription, loading: userSubLoading} = useRequest(() => getCurrentPlan())
  const {subscription} = userSubscription || {}

  if (userSubLoading) {
    return <div className="full-screen flex-center">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  }

  return <div className="full-screen flex-center">
    {subscription?.status === 'active' && <div>
      <Result
        status="success"
        title="Payment Successed"
        subTitle="The subscription is active."
      >
        <Button href="/">To Home</Button>
      </Result>
    </div>}

    {subscription?.status !== 'active' && <div>
      <Result
        status="error"
        title="Payment Successed"
        subTitle="The subscription is inactive."
      >
        <Button href="/pricing">To Pricing</Button>
      </Result>
    </div>}
    
  </div>
}